/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RoleGroupDto } from '../../models/role-group-dto';

export interface ApiRoleGet$Params {
  roleGroupId?: string;
}

export function apiRoleGet(http: HttpClient, rootUrl: string, params?: ApiRoleGet$Params, context?: HttpContext): Observable<StrictHttpResponse<RoleGroupDto>> {
  const rb = new RequestBuilder(rootUrl, apiRoleGet.PATH, 'get');
  if (params) {
    rb.query('roleGroupId', params.roleGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RoleGroupDto>;
    })
  );
}

apiRoleGet.PATH = '/api/role';
